const NAMES = ['50', '100', '200', '300', '400', '500', '600', '700', '800', '900', '950'];
const WHITE_MIX = [0.92, 0.78, 0.62, 0.42, 0.2];
const BLACK_MIX = [0.12, 0.25, 0.4, 0.55, 0.7];

function hexToRgb(hex: string) {
  const value = hex.replace('#', '');
  return [0, 2, 4].map((offset) => parseInt(value.slice(offset, offset + 2), 16));
}

function mix(color: number[], target: number, amount: number) {
  return color.map((channel) => Math.round(channel + (target - channel) * amount));
}

function compatiblePalette(hex: string) {
  const base = hexToRgb(hex);
  return [
    ...WHITE_MIX.map((amount) => mix(base, 255, amount)),
    base,
    ...BLACK_MIX.map((amount) => mix(base, 0, amount)),
  ];
}

export function applyBrandPalette(primary: string, secondary: string) {
  const root = document.documentElement;
  ([['primary', primary], ['accent', secondary]] as const).forEach(([name, hex]) => {
    const colors = compatiblePalette(hex);
    NAMES.forEach((step, index) => {
      root.style.setProperty(`--${name}-${step}`, colors[index].join(' '));
    });
  });
}

export function clearBrandPalette() {
  const root = document.documentElement;
  for (const name of ['primary', 'accent']) for (const step of NAMES) root.style.removeProperty(`--${name}-${step}`);
}
